export const environment = {
  production: true,
  host: 'https://polar.senzmate.com/service',
  googleMapKey: 'AIzaSyAca9W5Y8feCn8ni1s7jV7tjPICtWcMvD8',
  client_id:"polar-client",
  client_secret:"polar-secret",
  azureAd: {
      clientId:'78414668-f799-441b-9c3a-8ab3a4733117',
      tenantId: 'common'
      },
    azure:{
      planEntryId:"plan-test01",
      planSnapId:"plan-test02"
    }
};
